module.exports = __webpack_public_path__ + "img/stage-3.77c550eb.png";